
export type Role = 'OWNER' | 'MANAGER' | 'CASHIER';

// Features from Tenant.features (JSON)
export type FeatureKey = 'inventory' | 'tables' | 'kitchen' | 'appointments' | 'crm' | 'batches' | 'recipes';

export interface ModuleConfig {
    roles: Role[];
    feature?: FeatureKey;
}

export const PERMISSIONS_MATRIX: Record<string, ModuleConfig> = {
    // POS & Sales
    'POS': { roles: ['OWNER', 'MANAGER', 'CASHIER'] },
    'POS_DISCOUNT': { roles: ['OWNER', 'MANAGER'] }, // Discount permission separated from basic POS access
    // Gift/regalía access is granted to CASHIER too (unlike POS_DISCOUNT) —
    // the real gate is the tenant's GiftPolicy cost limit (defaults to 0 for
    // CASHIER), configured from the same screen as discount limits, not a
    // separate permissions wall.
    'POS_GIFT': { roles: ['OWNER', 'MANAGER', 'CASHIER'] },
    'SALES_HISTORY': { roles: ['OWNER', 'MANAGER', 'CASHIER'] },
    'CASH_REGISTER': { roles: ['OWNER', 'MANAGER', 'CASHIER'] },

    // Quotes
    'QUOTES': { roles: ['OWNER', 'MANAGER', 'CASHIER'] },

    // Promotions & pricing (read-only view for cashiers)
    'PROMOTIONS': { roles: ['OWNER', 'MANAGER', 'CASHIER'] },

    // Restaurant
    'KITCHEN': { roles: ['OWNER', 'MANAGER', 'CASHIER'], feature: 'kitchen' },
    'TABLES': { roles: ['OWNER', 'MANAGER', 'CASHIER'], feature: 'tables' },
    'MENU': { roles: ['OWNER', 'MANAGER'] }, // Product Mgmt

    // Core
    'INVENTORY': { roles: ['OWNER', 'MANAGER', 'CASHIER'], feature: 'inventory' },
    'REPORTS': { roles: ['OWNER', 'MANAGER'] },
    'CUSTOMERS': { roles: ['OWNER', 'MANAGER', 'CASHIER'], feature: 'crm' }, // view, pay, print
    'CUSTOMERS_EDIT': { roles: ['OWNER', 'MANAGER'], feature: 'crm' }, // create, edit, delete
    'CUSTOMERS_CREATE': { roles: ['OWNER', 'MANAGER', 'CASHIER'], feature: 'crm' }, // quick-create from POS

    // Admin — Configuración es solo OWNER (alineado con el backend access.matrix).
    'SETTINGS': { roles: ['OWNER'] },
    'USERS': { roles: ['OWNER', 'MANAGER'] },
    'WAREHOUSES': { roles: ['OWNER', 'MANAGER'] },

    // Fiscal invoicing config (CAI + rangos autorizados) — CASHIER never
    // administers this; printing a Factura is a POS-level action, not gated here.
    'FISCAL': { roles: ['OWNER', 'MANAGER'] },

    // Finance (Fase 4 of the navigation/IA plan) — cuentas por pagar/gastos.
    // CASHIER never sees this module.
    'FINANCE': { roles: ['OWNER', 'MANAGER'] },
};

export type ModuleKey = keyof typeof PERMISSIONS_MATRIX;
